export const BASE_URL = "https://www.peslar.com";
export const OG_IMAGE = `${BASE_URL}/og-image.png`;

export type PageMeta = {
  title: string;
  description: string;
  path: string;
  structuredData?: object;
};

export const homeMeta = (description: string): PageMeta => ({
  title: "Free Online Tools | Peslar.com",
  description,
  path: "/",
  structuredData: {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Peslar.com",
    url: `${BASE_URL}/`,
  },
});

export const toolsMeta = (description: string): PageMeta => ({
  title: "All Free Tools | Peslar.com",
  description,
  path: "/tools",
});

export const toolMeta = (
  slug: string,
  name: string,
  description: string,
  faq: { q: string; a: string }[] = [],
): PageMeta => {
  const software = {
    "@type": "SoftwareApplication",
    name,
    description,
    applicationCategory: "WebApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
    url: `${BASE_URL}/tools/${slug}`,
  };

  const faqPage = faq.length
    ? {
        "@type": "FAQPage",
        mainEntity: faq.map(({ q, a }) => ({
          "@type": "Question",
          name: q,
          acceptedAnswer: { "@type": "Answer", text: a },
        })),
      }
    : null;

  return {
    title: `${name} | Free Tools | Peslar.com`,
    description,
    path: `/tools/${slug}`,
    structuredData: {
      "@context": "https://schema.org",
      "@graph": faqPage ? [software, faqPage] : [software],
    },
  };
};
